import type { SponsorContract } from '../../engine/SponsorSystem';
import { applySponsorMultipliers } from '../../engine/SponsorSystem';

export type RaceMode = 'time_trial' | 'vs_rivals' | 'open_world_event';

export type RaceRewardContext = {
  mode: RaceMode;
  place: number;
  timeSec: number;
  driftScore: number;
  heatLevel: number;
  districtTier: 1 | 2 | 3;
  sponsor: SponsorContract | null;
};

export type RaceRewards = { money: number; xp: number };

export function computeRaceRewards(ctx: RaceRewardContext): RaceRewards {
  let money = 450 * ctx.districtTier;
  let xp = 110 * ctx.districtTier;

  if (ctx.place === 1) {
    money *= 2.2;
    xp *= 2.0;
  } else if (ctx.place === 2) {
    money *= 1.5;
    xp *= 1.3;
  } else if (ctx.place === 3) {
    money *= 1.2;
    xp *= 1.1;
  }

  if (ctx.mode === 'time_trial') {
    if (ctx.timeSec > 0 && ctx.timeSec < 100) {
      money += 300 * ctx.districtTier;
      xp += 80 * ctx.districtTier;
    } else if (ctx.timeSec > 0 && ctx.timeSec < 130) {
      money += 160 * ctx.districtTier;
      xp += 40 * ctx.districtTier;
    }
  }

  if (ctx.driftScore >= 800) {
    money += 180 * ctx.districtTier;
    xp += 60 * ctx.districtTier;
  } else if (ctx.driftScore >= 400) {
    money += 80 * ctx.districtTier;
    xp += 25 * ctx.districtTier;
  }

  money += ctx.heatLevel * 120 * ctx.districtTier;
  xp += ctx.heatLevel * 40 * ctx.districtTier;

  const mul = applySponsorMultipliers(ctx.sponsor, Math.floor(money), Math.floor(xp));
  return { money: mul.money, xp: mul.xp };
}
